import SpecificationService from "../services/SpecificationService";

export default {
  namespaced: true,
  state: {
    prodspecification: null,
    prodcertification: null,
    displayspecifications: null
  },
  getters: {
    getSpecification: state => state.prodspecification,
    getCertification: state => state.prodcertification
  },
  mutations: {
    UPDATE_SPECIFICATION(state, newSpec) {
      state.prodspecification = newSpec.Specifications;
      state.prodcertification = newSpec.Certifications;
    },
    CLEAR_SPECIFICATION(state) {
      this._vm.$set(state, 'prodspecification', null);
      this._vm.$set(state, 'prodcertification', null);
      this._vm.$set(state, 'displayspecifications', null);
    },
    RESTORE_STATE_FROM_LOCAL_STORAGE(state, data) {
      Object.assign(state, data.enhancedProductSpecs);
    }
  },
  actions: {
    loadProductSpecification({ commit }, { seriesId, skuId }) {
      return SpecificationService.getSpecification(seriesId, skuId)
        .then(({ data }) => data)
        .then(data => commit("UPDATE_SPECIFICATION", data))
        .catch(e => {
          // TODO: error handling
          throw e;
        });
    },
    clearProductSpecification({ commit }) {
      return commit("CLEAR_SPECIFICATION");
    },
    restoreStateFromLocalStorage({ commit }, enhancedProductSpecs) {
      commit("RESTORE_STATE_FROM_LOCAL_STORAGE", {
        enhancedProductSpecs
      });
    },
  }
};
